
export default {
  'how_it_works.title': 'How Pink Paradise Works',
  'how_it_works.subtitle': 'Discover our platform and how to make the most of it',
  'how_it_works.for_clients': 'For Clients',
  'how_it_works.for_escorts': 'For Escorts',
  'how_it_works.secure_private': 'Secure & Private',
  'how_it_works.verified_profiles': 'Verified Profiles',
  'how_it_works.secure_payments': 'Secure Payments',
  
  // For clients section
  'how_it_works.browse_profiles': 'Browse profiles',
  'how_it_works.browse_profiles_desc': 'Explore escorts\' profiles with detailed information.',
  'how_it_works.subscribe': 'Subscribe',
  'how_it_works.subscribe_desc': 'Choose a subscription tier that fits your needs.',
  'how_it_works.connect': 'Connect',
  'how_it_works.connect_desc': 'Message escorts directly through our secure platform.',
  'how_it_works.arrange': 'Arrange meetings',
  'how_it_works.arrange_desc': 'Schedule discreet encounters with complete privacy.',
  
  // For escorts section
  'how_it_works.create_profile': 'Create your profile',
  'how_it_works.create_profile_desc': 'Showcase your personality and services.',
  'how_it_works.get_verified': 'Get verified',
  'how_it_works.get_verified_desc': 'Complete our verification process to earn client trust.',
  'how_it_works.offer_subscriptions': 'Offer subscriptions',
  'how_it_works.offer_subscriptions_desc': 'Create fan subscriptions at €5/month for exclusive content.',
  'how_it_works.manage_bookings': 'Manage bookings',
  'how_it_works.manage_bookings_desc': 'Full control over your schedule and client selection.',
  
  // Feature descriptions
  'how_it_works.secure_private_desc': 'End-to-end encryption and advanced privacy features protect your identity.',
  'how_it_works.verified_profiles_desc': 'Every escort is verified to ensure authentic experiences and safety.',
  'how_it_works.secure_payments_desc': 'Discreet billing and multiple payment options for your convenience.',
  
  // FAQ section
  'how_it_works.faq': 'Frequently Asked Questions',
  'how_it_works.faq_privacy': 'How is my privacy protected?',
  'how_it_works.faq_privacy_answer': 'Your privacy is our top priority. All communications are encrypted, and personal information is protected with industry-leading security measures.',
  'how_it_works.faq_subscription': 'What subscription tiers are available?',
  'how_it_works.faq_subscription_answer': 'We offer free browsing, Teaser, Regular, and VIP subscription tiers. Each tier provides different levels of access to escort information and features.',
  'how_it_works.faq_verification': 'How do escort verifications work?',
  'how_it_works.faq_verification_answer': 'Escorts undergo a comprehensive verification process including ID verification, photo verification, and background checks to ensure authenticity.',
  
  // Call to action
  'how_it_works.ready': 'Ready to get started?',
  'how_it_works.join_today': 'Join Pink Paradise today and discover a new world of authentic encounters.',
  'how_it_works.create_account': 'Create an Account',
  'how_it_works.explore_profiles': 'Explore Profiles',
};
